import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

export default function LoginPage({ onLogin }) {
  const login = useGoogleLogin({
    onSuccess: (res) => onLogin(res.access_token),
    onError: (err) => console.error('登入失敗', err),
    scope: [
      'https://www.googleapis.com/auth/calendar.readonly',
      'https://www.googleapis.com/auth/spreadsheets',
      'https://www.googleapis.com/auth/drive.file',
    ].join(' '),
  });

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>課程管理系統</div>
        <div style={styles.sub}>瑪斯特健身工作坊</div>
        <p style={styles.desc}>
          連結 Google 帳號後，系統將自動讀取行事曆課程紀錄，
          並同步學員資料至 Google Sheets。
        </p>
        <button style={styles.btn} onClick={() => login()}>
          <svg width="18" height="18" viewBox="0 0 48 48" style={{ marginRight: 8, flexShrink: 0 }}>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          使用 Google 帳號登入
        </button>
        <p style={styles.note}>
          僅請求行事曆讀取、試算表讀寫、雲端硬碟檔案存取權限
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f5f5',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    border: '0.5px solid #e0e0e0',
    padding: '40px 36px',
    width: 380,
    textAlign: 'center',
  },
  logo: {
    fontSize: 22,
    fontWeight: 600,
    color: '#222',
    marginBottom: 6,
  },
  sub: {
    fontSize: 14,
    color: '#888',
    marginBottom: 20,
  },
  desc: {
    fontSize: 13,
    color: '#555',
    lineHeight: 1.7,
    marginBottom: 28,
    textAlign: 'left',
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '11px 20px',
    background: '#fff',
    border: '0.5px solid #ccc',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 500,
    color: '#222',
    marginBottom: 16,
  },
  note: {
    fontSize: 11,
    color: '#aaa',
    lineHeight: 1.6,
  },
};
